import { PageDto } from "../dto/page-dto";

export function EMPTY_PAGE<T>(): PageDto<T> {
  return {
    content: [],
    first: false,
    last: false,
    number: 0,
    numberOfElements: 0,
    pageable: {
      offset: 0,
      paged: true,
      sort: {
        unsorted: false,
        sorted: true,
      },
      pageSize: 0,
      pageNumber: 0,
      unpaged: false,
    },
    size: 0,
    sort: {
      unsorted: false,
      sorted: true,
    },
    totalElements: 0,
    totalPages: 0,
  };
}
